import {
  Button,
  ConfirmationModalStyle,
  Close
} from "@/imports-files/components/common-modal/common-modal";
import { useTranslation } from "react-i18next";
import { ButtonStyle } from "@/imports-files/common/common";

const ConfirmationModal = (props) => {
  const {t} = useTranslation()
  return (
    <div className={`${props.noOverlay ? '' : ConfirmationModalStyle.ModalOverlay}`}>
      <div className={`${props.noOverlay ? '' : ConfirmationModalStyle.Modal}`}>
        <div className={`${props.noOverlay ? '' : ConfirmationModalStyle.Modal__Container}`}>
          <div className={`${ConfirmationModalStyle.Modal__Container__Heading__Close}`}>
            {props.heading && (
              <div
                className={`${ConfirmationModalStyle.Modal__Container__Heading}`}
              >
                {props.heading}
              </div>
            )}

            {props.isCloseRequired && <div
              className={`${FormModalStyle.Modal__Container__CloseSection}`}
              onClick={()=> {props.closeBtnPopup(false)}}>
              <Close/>
            </div>}
          </div>
          <div
            className={`${ConfirmationModalStyle.Modal__Container__Text}`}
          >
            {props.message}
            {props.isMergeAvailable && <div className={ComponentStyle.ConfirmationModal__MergeNotice}>* Close the modal if you wish to accept the candidate as a new application</div>}
          </div>
          <div className={`${ConfirmationModalStyle.Modal__Container__ButtonSection} ${props.className}`}>
            <Button
              buttonstyle={ButtonStyle.secondarybtn}
              onClick={() => {
                props.closeModal();
              }}
            >
              {props.texts?.button1_text || t('button:cancel')}
            </Button>
            <Button
              buttonstyle={`${ButtonStyle.primarybtn}`}
              disabled={props.texts?.button2_disabled}
              onClick={() => {
                props.btnAction();
              }}
            >
              {props.texts?.button2_text || t('button:delete')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ConfirmationModal;
